import React from "react";
import { Header } from "../components/shared";
import { CheckoutFooter } from "../components/checkout";
import {
  AboutHero,
  TeamSection,
  StoryTimeline,
  AboutFeatures,
  ContactSection,
} from "../components/about";
import { SEO, generateBreadcrumbSchema } from "../seo";
import { useTranslation } from "../hooks/useTranslation";

const About = () => {
  const { t } = useTranslation('about');
  const breadcrumbSchema = generateBreadcrumbSchema([
    { name: 'Home', path: '' },
    { name: 'About', path: '/about' },
  ]);

  return (
    <div className="about-container">
      <SEO schema={breadcrumbSchema} />
      <h1 className="sr-only">{t('hero.title', 'About SunCatchers')}</h1>
      <div className="about-content">
        <Header />
        <AboutHero />
        <TeamSection />
        <StoryTimeline />
        <AboutFeatures />
        <ContactSection />
        <CheckoutFooter />
      </div>
    </div>
  );
};

export default About;
